import * as rt from 'runtypes';
import { OTArtifactRunType } from './ot';
import type { ValidGlobalArtifactType } from './globalArtifactPicker';

const AuthorFieldsRunType = rt.Record({
  createdBy: rt.Number,
  createdByUuid: rt.Optional(rt.Union(rt.String, rt.Null)),
  updatedBy: rt.Number,
  updatedByUuid: rt.Optional(rt.Union(rt.String, rt.Null)),
});

const TimestampFieldsRunType = rt.Record({
  createdAt: rt.Union(rt.InstanceOf(Date), rt.String),
  updatedAt: rt.Union(rt.InstanceOf(Date), rt.String),
});
type TimestampFieldsType = rt.Static<typeof TimestampFieldsRunType>;

const IdFieldRunType = rt.Record({ id: rt.Number });
type IdFieldType = rt.Static<typeof IdFieldRunType>;

const VersionRunType = rt.Record({ version: rt.Number });
type VersionType = rt.Static<typeof VersionRunType>;

const VersionableRunType = rt.Record({
  artifactVersionId: rt.Union(rt.Null, rt.Number).optional(),
});

const AuditableRunType = VersionRunType.And(TimestampFieldsRunType).And(AuthorFieldsRunType);
type AuditableType = rt.Static<typeof AuditableRunType>;

const ArtifactKeyRunType = rt.Record({
  type: OTArtifactRunType,
  id: rt.Number,
});
type ArtifactKey = rt.Static<typeof ArtifactKeyRunType>;

type GlobalArtifactKey = {
  type: ValidGlobalArtifactType;
  id: number;
};

type NestedGlobalArtifactKey = GlobalArtifactKey & {
  children: NestedGlobalArtifactKey[];
  level: number;
  title: string;
  template: boolean;
  globalTemplate: boolean;
  briefId: number;
};

const isArtifactKey = (obj: unknown): obj is ArtifactKey => {
  return ArtifactKeyRunType.guard(obj);
};

const BriefArtifactKeyRunType = rt.Record({
  type: OTArtifactRunType,
  id: rt.Number,
  briefId: rt.Number,
});
type BriefArtifactKey = rt.Static<typeof BriefArtifactKeyRunType>;

const DeletedMetadataRunType = rt.Record({
  parentKeys: rt.Array(ArtifactKeyRunType),
  childKeys: rt.Optional(rt.Array(ArtifactKeyRunType)),
});
type DeletedMetadataType = rt.Static<typeof DeletedMetadataRunType>;

const DeletableRecordDBRunType = rt.Record({
  deleted: rt.Boolean,
  deletedMetadata: DeletedMetadataRunType.nullable(),
});
type DeletableRecordDBType = rt.Static<typeof DeletableRecordDBRunType>;

export type {
  TimestampFieldsType,
  AuditableType,
  IdFieldType,
  ArtifactKey,
  BriefArtifactKey,
  DeletedMetadataType,
  DeletableRecordDBType,
  VersionType,
  GlobalArtifactKey,
};
export {
  ArtifactKeyRunType,
  AuditableRunType,
  AuthorFieldsRunType,
  BriefArtifactKeyRunType,
  DeletedMetadataRunType,
  DeletableRecordDBRunType,
  IdFieldRunType,
  isArtifactKey,
  NestedGlobalArtifactKey,
  TimestampFieldsRunType,
  VersionRunType,
  VersionableRunType,
};
